import { AxiosResponse } from "axios";
import { apimSubscriptionKey, baseUrl } from "../apiUrl";
import { AxiosClient } from "../../utils/AxiosClient";
import { IUser } from "../homesites/homesites.types";


export interface IConcierge {
       displayName?: string | null;
       givenName?: string | null;
       mail?: string | null;
       userPrincipalName?: string | null;
}

export interface IGraphResponse {
       "@odata.context": string;
       value: IConcierge[];
}


export const getConcierges = async (groupId: string): Promise<IUser[]> => {
       try {
              const headers = {
                     "Content-Type": "application/json",
                     "Ocp-Apim-Subscription-Key": apimSubscriptionKey
              }
              const serviceUrl = `${baseUrl}/graphapi/v1/groups/${groupId}/members`;
              const response: AxiosResponse<IGraphResponse> = await AxiosClient.get<IGraphResponse>(serviceUrl, { headers });
              return response.data.value.map((concierge) => ({
                     name: concierge.displayName!!,
                     email: concierge.mail!!
              }));
       } catch (error) {
              console.error("Error fetching concierges:", error);
              throw error;
       }
};
